export default __webpack_public_path__ + "static/media/swim.58916aa8.svg";